if (!customElements.get('swarah-gift-wrap')) {
  let queue = Promise.resolve();
  class SwarahGiftWrap extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.toggle = this.querySelector('[data-gift-toggle]');
      this.message = this.querySelector('[data-gift-message]');
      this.status = this.querySelector('.sl-gift-status');
      this.retry = this.querySelector('[data-gift-retry]');
      this.saved = JSON.stringify(this.attributesValue());
      this.toggle.addEventListener('change', () => {
        this.updateFields();
        this.save().catch(() => {});
      }, options);
      this.message.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.setBusy(true);
        this.timer = setTimeout(() => this.save().catch(() => {}), 300);
      }, options);
      this.message.addEventListener('change', () => this.save().catch(() => {}), options);
      this.retry.addEventListener('click', () => this.save().catch(() => {}), options);
      document.addEventListener('submit', async (event) => {
        if (event.target.id !== 'cart-form' || this.resubmitting) return;
        if (!this.pending && !this.timer && this.saved === JSON.stringify(this.attributesValue())) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const form = event.target;
        const submitter = event.submitter;
        try {
          await this.save();
          this.resubmitting = true;
          form.requestSubmit(submitter);
        } catch {
          this.retry.focus();
        } finally {
          this.resubmitting = false;
        }
      }, { ...options, capture: true });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
    }
    attributesValue() {
      return { 'Gift wrapping': this.toggle.checked ? 'Yes' : '', 'Gift message': this.toggle.checked ? this.message.value.trim() : '' };
    }
    updateFields() {
      this.querySelector('.sl-gift-note').hidden = !this.toggle.checked;
      this.message.disabled = !this.toggle.checked;
      this.querySelector('[data-gift-value]').value = this.toggle.checked ? 'Yes' : '';
    }
    setBusy(busy) {
      this.setAttribute('aria-busy', String(busy));
      this.closest('.cart-drawer__summary, .cart-summary__inner')?.querySelectorAll('.additional-checkout-buttons').forEach((buttons) => {
        buttons.inert = busy;
      });
      if (busy) this.status.textContent = this.dataset.saving;
    }
    save() {
      clearTimeout(this.timer);
      this.timer = null;
      const attributes = this.attributesValue();
      const snapshot = JSON.stringify(attributes);
      if (this.pending && this.requested === snapshot) return this.pending;
      if (!this.pending && this.saved === snapshot) {
        this.setBusy(false);
        this.status.textContent = this.dataset.saved;
        return Promise.resolve();
      }
      this.requested = snapshot;
      this.updateFields();
      this.setBusy(true);
      this.retry.hidden = true;
      const task = queue.catch(() => {}).then(async () => {
        const response = await fetch(this.dataset.updateUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes }) });
        if (!response.ok) throw new Error('Gift preference update failed');
        await response.json();
        this.saved = snapshot;
      });
      queue = task;
      this.pending = task;
      task.then(() => {
        if (this.pending !== task) return;
        this.pending = null;
        this.setBusy(false);
        this.status.textContent = this.dataset.saved;
      }, () => {
        if (this.pending !== task) return;
        this.pending = null;
        this.setBusy(false);
        this.status.textContent = this.dataset.error;
        this.retry.hidden = false;
      });
      return task;
    }
  }
  customElements.define('swarah-gift-wrap', SwarahGiftWrap);
}
